import { useGetAllApartmentsByTrainerIdCourseId } from "../../../assets/nodeApi/getApi/getAdminApi";


export const useApartmentNodeOptions = (trainerId,CourseId) => {
    const { data: apartmentForCourseList, isLoading: isApartmentForCourseLoading } = useGetAllApartmentsByTrainerIdCourseId(trainerId, {course_id:CourseId})
      const ApartmentOptionsForCourse = apartmentForCourseList?.data?.map(item => ({
        id: item.apartment_id,
        label: item.apartment_name,
        value: item.apartment_name,
        ...item
    }));

    return {
        ApartmentForCourse:{
            options:ApartmentOptionsForCourse,
            isLoading:isApartmentForCourseLoading
        }
    };
};
